import React, { Suspense } from 'react';

import { Outlet } from 'react-router-dom';

import { MainFooter } from '@src/components/organisms/main-footer';
import { MainHeader } from '@src/components/organisms/main-header';
import { MainMenu } from '@src/components/organisms/main-menu';
import { TopMenu } from '@src/components/organisms/top-menu';
import { bemClassName } from '@src/utils/bem';

import { StyledMainLayout } from './styles';
import { LoadingIndicator } from '../../components/atoms/loading-indicator';

const b = bemClassName('main-layout');

const MainLayout = ({ showHeader = true }) => {
  return (
    <StyledMainLayout>
      <div className={b()}>
        <div className={b('desktop-menu')}>
          <MainMenu />
        </div>
        <div className={b('mobile-menu')}>
          <TopMenu />
        </div>
        {showHeader && <MainHeader variant="small" />}
        <div className={b('container')}>
          <Suspense
            fallback={
              <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '60vh' }}>
                <LoadingIndicator />
              </div>
            }
          >
            <Outlet />
          </Suspense>
        </div>
        <MainFooter />
      </div>
    </StyledMainLayout>
  );
};

export default MainLayout;
